__turbopack_context__.v({
  "column-separator": "style-module-scss-module__MuEjRq__column-separator",
  "component": "style-module-scss-module__MuEjRq__component",
  "footer-group-collapsable": "style-module-scss-module__MuEjRq__footer-group-collapsable",
  "footer-group-not-collapsable": "style-module-scss-module__MuEjRq__footer-group-not-collapsable",
  "heading": "style-module-scss-module__MuEjRq__heading",
  "heading-border": "style-module-scss-module__MuEjRq__heading-border",
  "layout-container-with-separators": "style-module-scss-module__MuEjRq__layout-container-with-separators",
  "layout-container-without-separators": "style-module-scss-module__MuEjRq__layout-container-without-separators",
  "links-collapsable": "style-module-scss-module__MuEjRq__links-collapsable",
  "links-container": "style-module-scss-module__MuEjRq__links-container",
  "row-border": "style-module-scss-module__MuEjRq__row-border",
});
